module.exports = __webpack_public_path__ + "static/media/mountains.d38ad3c8.png";